// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-map-container {
    height: calc(1vh * 89);
    height: calc(var(--vh, 1vh) * 89);
    z-index: 0;
}

.slide-map-container-tile {
    width: 100vw !important;
    height: 99.9vh !important; 
    height: calc(1vh * 99.9); 
    height: calc(var(--vh, 1vh) * 99.9);
    z-index: 0;
}

.slide-map-container-wbc {
	/* TODO: Spandan Check why width was hard-limited here, we do not need to hard limit width */
	width: 20vw !important;
	height: 86.3vh;
	height: calc(1vh * 86.3);
	height: calc(var(--vh, 1vh) * 86.3);
	z-index: 0;
}

.slide-map-container-consume-all {
	width: 100%;
	height: 100%;
	z-index: 0;
}

.slide-map-container-wbc-40x {
	/* width: 60vw !important; */
	height: 86.3vh;
	height: calc(1vh * 86.3);
	height: calc(var(--vh, 1vh) * 86.3);
	z-index: 0;
}

.slide-map-container-full {
	width: 100vw !important;
    height: 94vh;
    height: calc(1vh * 94);
    height: calc(var(--vh, 1vh) * 94);
    z-index: 0;
}

.slide-map-container-preview {
    width:80vw;
    height:60vh;
    height: calc(1vh * 60);
    height: calc(var(--vh, 1vh) * 60);
    z-index: 0;
}

.slide-map-original {
    /*width: 100vw !important;*/
    height: 100vh;
    z-index: 0;
}

.slide-map-container-brain {
    width: 96vw !important;
    height: 100vh;
    height: calc(1vh * 100);
    height: calc(var(--vh, 1vh) * 100);
    z-index: 0;
}

.overlayed-component {
    background-color: var(--overlayed-button-color);
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.slide-map-row{
    background-color: var(--main-bg-color) !important;
    overflow: hidden;
}

.slide-map-col{
    color: var(--main-bg-color) !important;
    background-color: var(--main-bg-color);
}

.no-pointer-activity {
    pointer-events:none;
}

.stop-presentation, .stop-presentation:hover, .stop-presentation:active, .stop-presentation:focus, .stop-presentation:visited {
    position: absolute;
    pointer-events: all;
    top: 3px;
    left: 45%;
    border-radius: 0 0 4px 4px;
    border-left: 3px solid #de3c2f;
    border-right: 3px solid #de3c2f;
    border-bottom: 3px solid #de3c2f;
    border-top: 0 solid #de3c2f;
    z-index: 200;
    background-color: #d3d3d354;
    color: #98251c;
    font-weight: bold;
    background-clip: padding-box;
}

.border-divider-top {
	height: 3px;
	width: 100%;
	top: 0;
}

.border-divider-left {
	width: 3px;
	height: 100%;
	top: 0;
	left: 0;
}

.border-divider-right {
	width: 3px;
	height: 100%;
	top: 0;
	right: 0;
}

.border-divider-bottom {
	height: 3px;
	width: 100%;
	bottom: 0;
	left: 0;
}

.border-divider {
    background-color: #de3c2f;
    position: absolute;
    z-index: 100;
}

.main-background-color {
    background: #111111;
}

.loading-message-slidemap {
    position: absolute;
    right: 1%;
    top: 1%;
    border: 1px solid #d9d9d9;
    padding: 7px;
    border-radius: 15px;
    width: 300px;
    text-align: center;
    z-index: 1000;
    opacity: 0.5;
}

.tab{
    background-color: #98251c;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/slidemap.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,mCAAmC;IACnC,UAAU;AACd;;AAEA;CACC,4FAA4F;CAC5F,sBAAsB;CACtB,cAAc;CACd,wBAAwB;CACxB,mCAAmC;CACnC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,wBAAwB;CACxB,mCAAmC;CACnC,UAAU;AACX;;AAEA;CACC,uBAAuB;IACpB,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,4EAA4E;AAChF;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;CACC,WAAW;CACX,WAAW;CACX,MAAM;AACP;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,MAAM;CACN,OAAO;AACR;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,WAAW;CACX,SAAS;CACT,OAAO;AACR;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".slide-map-container {\n    height: calc(1vh * 89);\n    height: calc(var(--vh, 1vh) * 89);\n    z-index: 0;\n}\n\n.slide-map-container-tile {\n    width: 100vw !important;\n    height: 99.9vh !important; \n    height: calc(1vh * 99.9); \n    height: calc(var(--vh, 1vh) * 99.9);\n    z-index: 0;\n}\n\n.slide-map-container-wbc {\n\t/* TODO: Spandan Check why width was hard-limited here, we do not need to hard limit width */\n\twidth: 20vw !important;\n\theight: 86.3vh;\n\theight: calc(1vh * 86.3);\n\theight: calc(var(--vh, 1vh) * 86.3);\n\tz-index: 0;\n}\n\n.slide-map-container-consume-all {\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 0;\n}\n\n.slide-map-container-wbc-40x {\n\t/* width: 60vw !important; */\n\theight: 86.3vh;\n\theight: calc(1vh * 86.3);\n\theight: calc(var(--vh, 1vh) * 86.3);\n\tz-index: 0;\n}\n\n.slide-map-container-full {\n\twidth: 100vw !important;\n    height: 94vh;\n    height: calc(1vh * 94);\n    height: calc(var(--vh, 1vh) * 94);\n    z-index: 0;\n}\n\n.slide-map-container-preview {\n    width:80vw;\n    height:60vh;\n    height: calc(1vh * 60);\n    height: calc(var(--vh, 1vh) * 60);\n    z-index: 0;\n}\n\n.slide-map-original {\n    /*width: 100vw !important;*/\n    height: 100vh;\n    z-index: 0;\n}\n\n.slide-map-container-brain {\n    width: 96vw !important;\n    height: 100vh;\n    height: calc(1vh * 100);\n    height: calc(var(--vh, 1vh) * 100);\n    z-index: 0;\n}\n\n.overlayed-component {\n    background-color: var(--overlayed-button-color);\n    border-radius: 8px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.slide-map-row{\n    background-color: var(--main-bg-color) !important;\n    overflow: hidden;\n}\n\n.slide-map-col{\n    color: var(--main-bg-color) !important;\n    background-color: var(--main-bg-color);\n}\n\n.no-pointer-activity {\n    pointer-events:none;\n}\n\n.stop-presentation, .stop-presentation:hover, .stop-presentation:active, .stop-presentation:focus, .stop-presentation:visited {\n    position: absolute;\n    pointer-events: all;\n    top: 3px;\n    left: 45%;\n    border-radius: 0 0 4px 4px;\n    border-left: 3px solid #de3c2f;\n    border-right: 3px solid #de3c2f;\n    border-bottom: 3px solid #de3c2f;\n    border-top: 0 solid #de3c2f;\n    z-index: 200;\n    background-color: #d3d3d354;\n    color: #98251c;\n    font-weight: bold;\n    background-clip: padding-box;\n}\n\n.border-divider-top {\n\theight: 3px;\n\twidth: 100%;\n\ttop: 0;\n}\n\n.border-divider-left {\n\twidth: 3px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n}\n\n.border-divider-right {\n\twidth: 3px;\n\theight: 100%;\n\ttop: 0;\n\tright: 0;\n}\n\n.border-divider-bottom {\n\theight: 3px;\n\twidth: 100%;\n\tbottom: 0;\n\tleft: 0;\n}\n\n.border-divider {\n    background-color: #de3c2f;\n    position: absolute;\n    z-index: 100;\n}\n\n.main-background-color {\n    background: #111111;\n}\n\n.loading-message-slidemap {\n    position: absolute;\n    right: 1%;\n    top: 1%;\n    border: 1px solid #d9d9d9;\n    padding: 7px;\n    border-radius: 15px;\n    width: 300px;\n    text-align: center;\n    z-index: 1000;\n    opacity: 0.5;\n}\n\n.tab{\n    background-color: #98251c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
